class DeviceWidth {
  constructor() {
    let mql = window.matchMedia("(max-width: 1023px)");
    this.isMobile = mql.matches;
    this.isIpadPro = window.matchMedia('(min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none)').matches;
  }
}

class SliderToInitialize {
  constructor(slides) {
    this.element = slides;
    this.toInitialize = this.shouldInitialize(slides);
  }

  shouldInitialize(slides) {
    if (slides === 'plp-slider' && !Antonioli.settings.isDesktop) {
      return false;
    }
    return true;
  }
}

//AT-814 handleize modificato per preservare careatteri con accenti.
class StringTransformer {
  constructor(str) {
      this.str = str;
  }

  transform() {
      // Convert to lowercase, preserving accented characters
      this.str = this.str.toLowerCase();

      const toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

      // Remove specific characters
      for (let i = 0; i < toReplace.length; ++i) {
          this.str = this.str.replace(new RegExp(`\\${toReplace[i]}`, 'g'), "");
      }

      // Replace spaces with dashes
      this.str = this.str.replace(/\s+/g, '-');

      // Replace all non-alphanumeric characters except accented characters and dashes with a dash
      this.str = this.str.replace(/[^a-z0-9\u00C0-\u024F-]+/g, "-");

      // Remove trailing dashes
      this.str = this.str.replace(/-+$/, "");

      // Remove leading dashes
      this.str = this.str.replace(/^-+/, "");

      return this.str;
  }
}

class ElementReorderer {
  constructor(elements, dataAttribute, position) {
    this.elements = Array.from(elements);
    this.dataAttribute = dataAttribute;
    this.position = position;
  }

  reorderElements() {
    if (!this.elements.length) {
      console.error('No elements found.');
      return;
    }

    this.clearIndices();

    const specialElements = this.elements.filter(el => el.dataset[this.dataAttribute] !== undefined);
    const otherElements = this.elements.filter(el => el.dataset[this.dataAttribute] === undefined);

    if (specialElements.length > 0) {
      const [firstSpecialElement] = specialElements;
      specialElements.shift();
      otherElements.splice(this.position, 0, firstSpecialElement);
      const reorderedElements = [...otherElements, ...specialElements];
      this.updateDOM(reorderedElements);
      this.assignIndices(reorderedElements);
    }
  }

  clearIndices() {
    this.elements.forEach(el => {
      el.removeAttribute('data-index'); // Rimuovi il vecchio attributo data-index
    });
  }

  updateDOM(elements) {
    const parent = this.elements[0]?.parentNode;

    if (parent) {
      parent.style.display = 'none';
      const fragment = document.createDocumentFragment();
      elements.forEach(el => fragment.appendChild(el));
      parent.innerHTML = '';
      parent.appendChild(fragment);
      parent.style.display = 'block'
    }
  }

  assignIndices(elements) {
    elements.forEach((el, index) => {
      el.setAttribute('data-index', index); // Assegna l'indice come attributo
    });
  }
}

class AccountParameterHandler {
  static setRedirectParam(param, value) {
    localStorage.setItem('redirect_param', param);
    localStorage.setItem(param, value);
  }

  static reloadWithParam(param) {
    const currentMarket = AntonioliCookieFunctions.getCookieValue("currentMarket") || '';
    const isOnRedirectUrl = ['account/register','/challenge'].some(url => window.location.href.includes(url));

    if (!isOnRedirectUrl && Antonioli.customerId != '') {
      window.location.href = `${currentMarket}account?${param}`;
      localStorage.removeItem('redirect_param');
      localStorage.removeItem(param);
    }
  }
}
